define('ET/ETRouter',[
    "evertrue",
    "jquery",
    "underscore",
    "backbone",
    "ET/ETModel",
    "models/UserModel",
    "models/FeaturesModel",
    "helpers/web-helpers",
    "react",
    "reactDOM",
    "helpers/analytics-helper",
], function ETRouterFactory ( EverTrue, $, _, Backbone, ETModel, UserModel, FeaturesModel, WebHelpers, React, ReactDOM, AnalyticsHelper) {

    // Extend the bacbone Model with our EverTrue model w/ defualt functionality
    var ETRouter = Backbone.Router.extend({
        before : {
            '*any': 'beforeRoute'
        },
        nonAuthRoutes : [
            'showLogin',
            'showHealthCheck',
            'doSessionJump',
            'defaultAction',
            'showUnauthorized'
        ],
        baseRoute : 'dashboard/reporting',

        // initialize function to start Backbone history and bind routin events
        initialize: function (query) {
            EverTrue.vent.on('reroute', this.reroute, this);
            this.on("route", function() {
                EverTrue.vent.trigger("route:change");
            });
        },

        beforeRoute : function(fragment, name, callback, args) {
            // Unmount React Components
            ReactDOM.unmountComponentAtNode(document.getElementById("guide"));
            ReactDOM.unmountComponentAtNode(document.getElementById("react-page"));

            EverTrue.referrer = EverTrue.referrer || Backbone.history.fragment;
            this.status = {
                fragment : fragment,
                name : name,
                callback : callback,
                args : args
            };

            // only check for session (therefore navigation) and authorization if it is a route that requires it
            if (this._requiresSession(name)) {
                if (!this._checkSession(name) ) {
                    EverTrue.logout({timeout: 200});
                    return false;
                } else if (!this.entered) {
                    this.entered = true;
                    this._enterApp();
                }
            }
        },

        _routeToReferrer : function(referrer){
            referrer = referrer || EverTrue.referrer;

            if ( !referrer || referrer.indexOf("login") !== -1 ){
                referrer = '/';
            }

            var features = new FeaturesModel();
            $.when(features.init()).then(function() {
                if (_.contains(features.get('features'), 'reporting:growth')) {
                    EverTrue.Router.baseRoute = 'dashboard/reporting';
                } else {
                    EverTrue.Router.baseRoute = 'data/importer';
                }
            });

            if (referrer === Backbone.history.fragment){
                this._callRouteCallback();
            } else {
                EverTrue.Router.navigate(referrer, {trigger: true});
            }
        },

        _callRouteCallback : function(){
            var args = this.status.args,
                callback = this.status.callback,
                name = this.status.name;

            callback && callback.apply(this, args);
            this.trigger.apply(this, ['route:' + name].concat(args));
            Backbone.history.trigger('route', this, name, args);
        },


        _enterApp : function(sid, oid, options) {
            var router = this;

            if (sid) {
                EverTrue.Session.set({id : sid}, {silent:true});
            } else {
                sid = EverTrue.Session.id;
            }
            EverTrue.Session.set({token : sid});
            EverTrue.Session.saveToStorage();
            AnalyticsHelper.setFullStoryUser(EverTrue.User);

            $.when(EverTrue.DNA.hardSet()).then(function(){
                if (oid) router._setNewOid(oid);

                // Make sure have permissions for org trying to log into
                var affs = EverTrue.User.get("affiliations"),
                    super_user = EverTrue.User.get("super_user"),
                    aff = null
                    oid = oid || EverTrue.Organization.get("id");

                if (_.isArray(affs)) {
                    orgs = _.pluck(affs, "organization");
                    aff = _.findWhere(orgs, {"id": parseInt(oid, 10)});
                } else if (affs && (affs.organization.id == oid)) {
                    aff = affs;
                }

                if (super_user || (!super_user && aff)) {
                    if (EverTrue.NavigationView) {
                        EverTrue.NavigationView.start();
                    }
                    router._routeToReferrer();
                    if (options && options.success && _.isFunction(options.success)) {
                        options.success();
                    }
                } else {
                    EverTrue.logout();
                    if (options && options.error && _.isFunction(options.error)) {
                        options.error();
                    }
                    EverTrue.alertView.alert("error", {message: "User does not have permission for this organization."})
                }
            });
        },

        _setNewOid : function(oid){
            this.oldOid = EverTrue.Organization.get('id');
            this.newOid = oid;
            EverTrue.Organization.set({'id': oid}, {silent : true});
        },

        // router helper functions
        reroute: function (options) {
            var url = (options.url) ? options.url : options;
            var trigger = (options.trigger) ? options.trigger : true;
            var replace = (options.replace) ? options.replace : false;

            if (window.isNode){
                window.redirect(url, {trigger: trigger, replace: replace});
                return;
            }
            this.navigate(url, {trigger: trigger, replace: replace} );
        },

        getUrlRoot : function(segments){
            var fullUrl = Backbone.history.fragment,
                urlSegments = fullUrl.split('/');
            return _.first(urlSegments, segments).join('/');
        },

        _requiresSession : function(callbackNameOverride){
            var isNonAuthRoute = $.inArray(callbackNameOverride, this.nonAuthRoutes ) !== -1;
            return !isNonAuthRoute;
        },

        _checkSession : function (callbackNameOverride) {
            // if for some reason we dont have a fragment - i.e. we're using node...
            var path = Backbone.history.fragment || window.location.pathname;
            // hack so the login redirect doesn't log overwrite the referrer
            if ( path.indexOf("login") !== -1 ) {
                EverTrue.referrer = path;
            }

            // lets make sure we have an oid
            var oid = (EverTrue.Organization && EverTrue.Organization.has('id')) ? true : false;
            // and a sid
            var sid = (EverTrue.Session && EverTrue.Session.has('id')) ? true : false;

            return (oid && sid) ? true : false;
        },

        // routes that hangle rerouting to/from external urls
        doSessionJump : function ( querystring ) {
            var router = this;
            this.entered = true;

            this.parseJumpQueryString(querystring);
            // Set the referrer to the route from the querystring
            EverTrue.referrer = this.route;

            // Enter the application
            router._enterApp(this.sid, this.oid);
        },

        parseJumpQueryString : function(querystring){
            // get the parameters from the splat
            var qsHash = EverTrue.getQueryStringHash( querystring );

            if ( typeof qsHash.oid == 'undefined' || EverTrue.isValidOID(qsHash.oid) )
                throw new Error('Invalid oid in sessionjump');
            this.oid = qsHash.oid;

            this.route = qsHash.jump || '';

            // map et_sid to sid, to support legacy mobile rewrites
            // TODO: let the rewrite map this?
            var sid;
            if ( typeof qsHash.et_sid != 'undefined' ) {
                this.sid = qsHash.et_sid;
            }
            else if ( typeof qsHash.sid != 'undefined' ) {
                this.sid = qsHash.sid;
            }
            else {
                throw new Error('Invalid sid in sessionjump');
            }
            if(!EverTrue.profileLeftButton) EverTrue.profileLeftButton = {};
            if(qsHash.myprofile){
                EverTrue.profileLeftButton.type = 'menu';
            }
            else if (qsHash.fromnative){
                EverTrue.profileLeftButton.type = 'native';
            }
            else{
                EverTrue.profileLeftButton.type = 'web';
            }
        },

        // Extended from https://github.com/fantactuka/backbone-route-filter
        /**
         * Override default route fn to call before/after filters
         *
         * @param {String} route
         * @param {String} name
         * @param {Function} [callback]
         * @return {*}
         */
        route: function(route, name, callback) {
            Backbone.history || (Backbone.history = new Backbone.History());
            if (!_.isRegExp(route)) route = this._routeToRegExp(route);
            if (!callback) callback = this[name];
            Backbone.history.route(route, _.bind(function(fragment) {
                var args = this._extractParameters(route, fragment);
                if (this._runFilters(this.before, fragment, name, callback, args, true)) {
                    callback && callback.apply(this, args);
                    this.trigger.apply(this, ['route:' + name].concat(args));
                    this.trigger('route', name, args);
                    Backbone.history.trigger('route', this, name, args);
                    this._runFilters(this.after, fragment, name, args, false);
                }
            }, this));
            return this;
        },

        /**
         * Run set of filters and stops if any of them failing (returns false)
         * @param filters
         * @param fragment
         * @param args
         * @param {boolean} stopOnError - will stop iterating over filters if any returns false
         * @return {boolean}
         * @private
         */
        _runFilters: function(filters, fragment, name, callback, args, stopOnError) {
          return _[stopOnError ? 'every' : 'each'](filters, function(fn, filter) {
            filter = _.isRegExp(filter) ? filter : this._routeToRegExp(filter);

            if (filter.test(fragment)) {
              fn = _.isFunction(fn) ? fn : this[fn];
              return fn.apply(this, [fragment, name, callback, args]) !== false;
            }

            return true;
          }, this);
        }
    });

    EverTrue.Router = ETRouter;
    return ETRouter;

});

